import React  from 'react';
import HiddenTag from '../../_components/HiddenTag';
import CancelledTag from '../../_components/CancelledTag';
import CompletedTag from '../../_components/CompletedTag';
import ExpiredTag from '../../_components/ExpiredTag';
import moment from 'moment-timezone';

export default function StatusTags(props) {
  const { project } = props;

  if (project.data.cancelled) {
    return (
      <div className="flex space-x-4">
        <CancelledTag resource={project} />
      </div>
    );
  }

  if (project.data.completed) {
    return (
      <div className="flex space-x-4">
        <CompletedTag resource={project} />
      </div>
    );
  }

  const diff = moment().diff(project.data.endDate, 'days');

  if (diff >= 0) {
    return (
      <div className="flex space-x-4">
        <ExpiredTag resource={project} />
      </div>
    );
  }

  return null;
}
